(function(Drupal, $, once){
    Drupal.behaviors.mo14 = {
        attach() {
            $(once('mo14', '.MO14')).each(function() {
                //appending youtube api to webpage
                var iframeScript = document.createElement('script');
                iframeScript.id = 'iframe-script';
                iframeScript.src = '//www.youtube.com/iframe_api';
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(iframeScript, firstScriptTag);

                const iframeIDs = [];

                $(".MO14").each(function () {
                    let UUID = self.crypto.randomUUID();
                    $(this).find(".MO14__video-iframe").attr('id', UUID);
                    iframeIDs.push(UUID);
                });

                window.onYouTubeIframeAPIReady = function() {
                    for(let i = 0; i < iframeIDs.length; i++) {
                        let player = createPlayer(iframeIDs[i]);
                    }
                }

                function createPlayer(playerID) {
                    return new YT.Player(playerID, {
                        events: {
                            'onStateChange': onPlayerStateChange
                        }
                    });
                }

                function onPlayerStateChange(event) {
                    const playerStates = {
                        "PLAYING": 1,
                        "BUFFERING": 3
                    };

                    if (event.data == playerStates.PLAYING || event.data == playerStates.BUFFERING) {
                        let targetID = event.target.g.id.toString();
                        $(`#${targetID}`).attr('tabindex', '0');
                        $(`#${targetID}`).parent().find('.MO14__placeholder').hide();
                    }
                }

                $(".MO14__placeholder").on('click', function () {
                    $(this).hide();
                    var $iframe = $(this).parent().find('iframe');
                    $iframe.get(0).contentWindow.postMessage(JSON.stringify({
                        event: 'command',
                        func: 'playVideo'
                    }), '*');
                });
            });
        }
    };
})(Drupal, jQuery, once);
